export default __webpack_public_path__ + "media/zurb/img/legacy/chop/chop-large-6a91f451cd0e6be2788e974189a649ea.png";